import { render, staticRenderFns } from "./pi6-work-type.vue?vue&type=template&id=53806044"
import script from "./pi6-work-type.vue?vue&type=script&lang=js"
export * from "./pi6-work-type.vue?vue&type=script&lang=js"
import style0 from "./pi6-work-type.vue?vue&type=style&index=0&id=53806044&prod&lang=less&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports